import * as React from "react";
const SvgVideo = props => <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" {...props}><path d="M8 5v14l11-7z" /></svg>;
export { SvgVideo as ReactComponent };